import { useSelector, useDispatch } from 'react-redux';
import useScript from '../useScript';
import { iRootState, Dispatch } from '../redux/store';

const LoadFortisScript = function LoadFortisScript(): null {
  const fortisConfigIsLoaded = useSelector(
    (state: iRootState) => state.currencyPay.isLoaded
  );

  const dispatch = useDispatch<Dispatch>();
  const onLoad = (): void => {
    dispatch.fortis.scriptIsLoaded();
  };

  const useScriptArguments = {
    url: window.AutoQuotes.config.fortisScriptUrl,
    load: fortisConfigIsLoaded,
    onLoad
  };
  useScript(useScriptArguments);

  return null;
};

export default LoadFortisScript;
